export default "__VITE_ASSET__lWSr_t33__"